webpackJsonp([172792206850227],{

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(165);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _emotionTheming = __webpack_require__(59);
	
	var _themeConstants = __webpack_require__(80);
	
	var _themeConstants2 = _interopRequireDefault(_themeConstants);
	
	var _EnquireNowButton = __webpack_require__(394);
	
	var _EnquireNowButton2 = _interopRequireDefault(_EnquireNowButton);
	
	var _stylesModule = __webpack_require__(1869);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _styledComponents = __webpack_require__(393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentSection = function ContentSection(props) {
	  var futureItemTitle = props.futureItemTitle,
	      futureItemDescription = props.futureItemDescription,
	      galleryPresent = props.galleryPresent,
	      webpsrc = props.webpsrc,
	      mainImage = props.mainImage,
	      mobileImage = props.mobileImage,
	      id = props.id;
	
	  return _react2.default.createElement(
	    _styledComponents.FutureTextItem,
	    null,
	    _react2.default.createElement(_styledComponents.FutureItemTitle, {
	      as: 'h3',
	      dangerouslySetInnerHTML: {
	        __html: futureItemTitle
	      }
	    }),
	    _react2.default.createElement(
	      _styledComponents.FutureItemDescription,
	      null,
	      futureItemDescription
	    ),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { query: '(max-device-width: 767px)' },
	      galleryPresent ? _react2.default.createElement(_styledComponents.FutureImageItem, null) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _styledComponents.FutureItemHead,
	          null,
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { query: '(min-device-width: 768px)' },
	            _react2.default.createElement(_styledComponents.FutureItemImg, {
	              dataSrc: webpsrc || mainImage,
	              alt: futureItemTitle,
	              className: 'lazyload'
	            })
	          ),
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { query: '(max-device-width: 767px)' },
	            _react2.default.createElement(_styledComponents.FutureItemImg, {
	              dataSrc: webpsrc || mobileImage,
	              alt: futureItemTitle,
	              className: 'lazyload'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _styledComponents.EnquireNowButtonContainer,
	      null,
	      _react2.default.createElement(_EnquireNowButton2.default, { id: id + '-enquire-button' })
	    )
	  );
	};
	
	var ImageSection = function ImageSection(props) {
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { query: '(min-device-width: 768px)' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _styledComponents.FutureItemHead,
	        null,
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: '(min-device-width: 768px)' },
	          _react2.default.createElement(_styledComponents.SectionImage, {
	            dataSrc: props.webpsrc || props.mainImage,
	            alt: props.futureItemTitle,
	            className: 'lazyload'
	          })
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: '(max-device-width: 767px)' },
	          _react2.default.createElement(_styledComponents.SectionImage, {
	            dataSrc: props.webpsrc || props.mobileImage,
	            alt: props.futureItemTitle,
	            className: 'lazyload'
	          })
	        )
	      )
	    )
	  );
	};
	
	var LeftImageComponent = function LeftImageComponent(props) {
	  return _react2.default.createElement(
	    _styledComponents.ImageAndContentContainer,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.vcenter, style: { width: props.imageWidth + '%' } },
	      _react2.default.createElement(ImageSection, props)
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.vcenter + ' ' + _stylesModule2.default.paddingLeft,
	        style: { width: props.contentWidth + '%' }
	      },
	      _react2.default.createElement(ContentSection, props)
	    )
	  );
	};
	
	LeftImageComponent.defaultProps = {
	  imageWidth: 40,
	  contentWidth: 60
	};
	
	var RightImageComponent = function RightImageComponent(props) {
	  return _react2.default.createElement(
	    _styledComponents.ImageAndContentContainer,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.vcenter + ' ' + _stylesModule2.default.paddingRight,
	        style: { width: props.contentWidth + '%' }
	      },
	      _react2.default.createElement(ContentSection, props)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.vcenter, style: { width: props.imageWidth + '%' } },
	      _react2.default.createElement(ImageSection, props)
	    )
	  );
	};
	RightImageComponent.defaultProps = {
	  imageWidth: 40,
	  contentWidth: 60
	};
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.componentDidMount = function componentDidMount() {};
	
	  Section.prototype.render = function render() {
	    var id = this.props.id;
	
	    return _react2.default.createElement(
	      _emotionTheming.ThemeProvider,
	      { theme: _themeConstants2.default },
	      _react2.default.createElement(
	        _styledComponents.FutureSection,
	        { id: id },
	        this.props.imagePosition === 'LEFT' ? _react2.default.createElement(LeftImageComponent, this.props) : _react2.default.createElement(RightImageComponent, this.props)
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 1869:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"vcenter":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---vcenter---3Ejb7","paddingLeft":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---paddingLeft---15AeO","paddingRight":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---paddingRight---hDZQK"};

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Section = __webpack_require__(1028);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _styledComponents = __webpack_require__(1030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventsDescriptionSection = function (_Component) {
	  _inherits(EventsDescriptionSection, _Component);
	
	  function EventsDescriptionSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EventsDescriptionSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImageAndContentSection = function (event, index) {
	      var eventId = event.eventId,
	          title = event.title,
	          description = event.description,
	          mainImage = event.mainImage,
	          mobileImage = event.mobileImage,
	          buttonText = event.buttonText;
	
	      return _react2.default.createElement(_Section2.default, {
	        id: eventId.toLowerCase(),
	        key: title,
	        futureItemDescription: description,
	        futureItemTitle: title,
	        imagePosition: index % 2 === 0 ? 'RIGHT' : 'LEFT',
	        mainImage: mainImage,
	        mobileImage: mobileImage,
	        buttonText: buttonText
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EventsDescriptionSection.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$eventsSection = this.props.eventsSection,
	        eventsSectionId = _props$eventsSection.eventsSectionId,
	        eventsList = _props$eventsSection.eventsList;
	
	
	    return _react2.default.createElement(
	      _styledComponents.SectionContainer,
	      { id: eventsSectionId },
	      _react2.default.createElement(
	        _ResponsiveContainer2.default,
	        null,
	        _react2.default.createElement(
	          _styledComponents.Wrapper,
	          null,
	          eventsList.map(function (event, index) {
	            return _this2.renderImageAndContentSection(event, index);
	          })
	        )
	      )
	    );
	  };
	
	  return EventsDescriptionSection;
	}(_react.Component);
	
	exports.default = EventsDescriptionSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Wrapper = exports.SectionDescription = exports.SectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionContainer = /*#__PURE__*/exports.SectionContainer = (0, _reactEmotion2.default)('section', {
	  target: 'ewus40u0'
	})('background-color:', _Colors2.default.blackDefault, ';padding-top:60px;padding-bottom:0px;', _mixins.mobile, '{padding-top:40px;font-size:14px;padding-bottom:0px;}');
	
	var SectionDescription = /*#__PURE__*/exports.SectionDescription = (0, _reactEmotion2.default)(_Din.Typo18GainsBoroDR, {
	  target: 'ewus40u1'
	})('line-height:1.67;letter-spacing:normal;padding-top:13px;width:81.3%;margin-bottom:25px;', _mixins.mobile, '{width:100%;margin-bottom:30px;}');
	
	var Wrapper = /*#__PURE__*/exports.Wrapper = (0, _reactEmotion2.default)('div', {
	  target: 'ewus40u2'
	})('display:flex;flex-direction:column;');

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SectionHeading = __webpack_require__(675);
	
	var _SectionHeading2 = _interopRequireDefault(_SectionHeading);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styledComponents = __webpack_require__(676);
	
	var _styledComponents2 = __webpack_require__(1032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IbCricketHostingSection = function (_Component) {
	  _inherits(IbCricketHostingSection, _Component);
	
	  function IbCricketHostingSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IbCricketHostingSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderHostedCompaniesList = function (hostedList) {
	      return _react2.default.createElement(
	        _styledComponents2.LogosWrapper,
	        null,
	        hostedList.map(function (logo) {
	          return _react2.default.createElement(
	            _styledComponents2.LogoInnerContainer,
	            { key: logo.imageUrl },
	            _react2.default.createElement(_styledComponents2.Logo, { src: logo.imageUrl })
	          );
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IbCricketHostingSection.prototype.render = function render() {
	    var eventsHostedAtHeader = this.props.eventsHostedAtHeader;
	    var eventsHostedAtHeaderHeading = eventsHostedAtHeader.eventsHostedAtHeaderHeading,
	        hostedList = eventsHostedAtHeader.hostedList,
	        footerDescription = eventsHostedAtHeader.footerDescription,
	        bottomDescription = eventsHostedAtHeader.bottomDescription;
	
	
	    return _react2.default.createElement(
	      _styledComponents2.IbCricketHostingSectionContainer,
	      { id: 'ibCricketHostedAtSection' },
	      _react2.default.createElement(
	        _styledComponents.ResponsiveContainer,
	        null,
	        _react2.default.createElement(_SectionHeading2.default, {
	          sectionHeadingText: eventsHostedAtHeaderHeading,
	          color: _Colors2.default.pumpkinOrange
	        }),
	        this.renderHostedCompaniesList(hostedList),
	        _react2.default.createElement(_styledComponents2.Description, {
	          dangerouslySetInnerHTML: {
	            __html: footerDescription
	          },
	          as: 'p'
	        }),
	        _react2.default.createElement(
	          _styledComponents2.BottomText,
	          null,
	          bottomDescription
	        )
	      )
	    );
	  };
	
	  return IbCricketHostingSection;
	}(_react.Component);
	
	exports.default = IbCricketHostingSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BottomText = exports.Description = exports.LogosWrapper = exports.Logo = exports.LogoInnerContainer = exports.IbCricketHostingSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IbCricketHostingSectionContainer = /*#__PURE__*/exports.IbCricketHostingSectionContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e1eyzg4n0'
	})('background-color:', _Colors2.default.darkTwoDefault, ';padding-top:60px;', _mixins.mobile, '{padding-top:40px;}');
	var LogoInnerContainer = /*#__PURE__*/exports.LogoInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1eyzg4n1'
	})('padding-left:25px;padding-right:25px;display:flex;justify-content:center;align-items:center;', _mixins.mobile, '{padding-left:0px;padding-right:0px;width:30%;}');
	var Logo = /*#__PURE__*/exports.Logo = (0, _reactEmotion2.default)('img', {
	  target: 'e1eyzg4n2'
	})('padding-top:10px;', _mixins.mobile, '{padding-top:30px;height:100px;object-fit:cover;}');
	var LogosWrapper = /*#__PURE__*/exports.LogosWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1eyzg4n3'
	})('display:flex;flex-wrap:wrap;', _mixins.mobile, '{justify-content:space-between;align-items:center;flex-wrap:wrap;}', (0, _mixins.customDevice)(1024, 1120), '{justify-content:space-between;}');
	var Description = /*#__PURE__*/exports.Description = (0, _reactEmotion2.default)(_Din.Typo16GainsBoroDR, {
	  target: 'e1eyzg4n4'
	})('text-align:center;margin-bottom:0px;', _mixins.mobile, '{margin-top:31px;font-size:14px;line-height:1.5;}span{color:', _Colors2.default.pumpkinOrange, ';font-family:Nort;font-size:36px;font-weight:bold;font-style:italic;padding-left:10px;padding-right:10px;}');
	
	var BottomText = /*#__PURE__*/exports.BottomText = (0, _reactEmotion2.default)(_Din.Typo12WhiteEightDR, {
	  target: 'e1eyzg4n5'
	})('opacity:0.8;line-height:2.33;letter-spacing:normal;text-align:right;color:#d9d9d9;padding-top:30px;padding-bottom:6px;', _mixins.mobile, '{text-align:center;font-size:9px;line-height:3.11;padding-top:40px;padding-bottom:0px;}');

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(676);
	
	var _navigationUtils = __webpack_require__(16);
	
	var _styledComponents2 = __webpack_require__(1034);
	
	var _styledComponents3 = __webpack_require__(393);
	
	var _EnquireNowButton = __webpack_require__(394);
	
	var _EnquireNowButton2 = _interopRequireDefault(_EnquireNowButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingPage = function (_Component) {
	  _inherits(LandingPage, _Component);
	
	  function LandingPage() {
	    _classCallCheck(this, LandingPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LandingPage.prototype.render = function render() {
	    var eventsLandingSection = this.props.eventsLandingSection;
	    var sectionId = eventsLandingSection.sectionId,
	        title = eventsLandingSection.title,
	        backgroundImageUrl = eventsLandingSection.backgroundImageUrl,
	        mobileBackgroundImageUrl = eventsLandingSection.mobileBackgroundImageUrl,
	        buttonText = eventsLandingSection.buttonText,
	        titleDescription = eventsLandingSection.titleDescription;
	
	    return _react2.default.createElement(
	      _styledComponents2.LandingSectionContainer,
	      {
	        id: sectionId,
	        desktopBackgroundImage: backgroundImageUrl,
	        mobileBackgroundImage: mobileBackgroundImageUrl
	      },
	      _react2.default.createElement(
	        _styledComponents.ResponsiveContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents2.SectionWrapper,
	          null,
	          _react2.default.createElement(
	            _styledComponents2.HeadingDescription,
	            null,
	            titleDescription
	          ),
	          _react2.default.createElement(_styledComponents2.Heading, {
	            dangerouslySetInnerHTML: {
	              __html: title
	            },
	            as: 'h1'
	          }),
	          _react2.default.createElement(
	            _styledComponents3.EnquireNowButtonContainer,
	            null,
	            _react2.default.createElement(_EnquireNowButton2.default, {
	              id: 'events-landing-section-get-in-touch-button'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return LandingPage;
	}(_react.Component);
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonDescription = exports.HeadingDescription = exports.Heading = exports.SectionWrapper = exports.ButtonContainer = exports.LandingSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Nort = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandingSectionContainer = /*#__PURE__*/exports.LandingSectionContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e1vectcb0'
	})('z-index:10;background-image:url(', function (props) {
	  return props.desktopBackgroundImage;
	}, '),linear-gradient(114deg,', _Colors2.default.black, ',rgba(18,18,18,0));background-size:cover;background-repeat:no-repeat;padding-top:130px;background-position-x:50%;background-position-y:bottom;', _mixins.mobile, '{background-image:url(', function (props) {
	  return props.mobileBackgroundImage;
	}, '),linear-gradient(to bottom,', _Colors2.default.black, ',rgba(18,18,18,0));min-height:100vh;}', (0, _mixins.customDevice)(768, 1024), '{min-height:471px;}position:relative;');
	
	var ButtonContainer = /*#__PURE__*/exports.ButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1vectcb1'
	})('background-color:', _Colors2.default.pumpkinOrange, ';padding-top:7px;padding-bottom:7px;padding-left:20px;padding-right:20px;cursor:pointer;:hover{text-decoration:none;}:focus{text-decoration:none;}', _mixins.mobile, '{padding-left:11px;padding-right:11px;}');
	var SectionWrapper = /*#__PURE__*/exports.SectionWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1vectcb2'
	})('display:flex;flex-direction:column;justify-content:center;align-items:flex-start;margin-top:119px;width:87%;margin-bottom:155px;', _mixins.mobile, '{width:100%;margin-top:55px;margin-bottom:60px;}', (0, _mixins.customDevice)(768, 899), '{width:100%;}', (0, _mixins.customDevice)(900, 1024), '{width:70.5%;}');
	var Heading = /*#__PURE__*/exports.Heading = (0, _reactEmotion2.default)(_Nort.Typo36WhiteTwoBN9I, {
	  target: 'e1vectcb3'
	})('line-height:1.36;letter-spacing:1px;margin-top:0px;margin-bottom:20px;', _mixins.mobile, '{font-size:24px;line-height:1.25;margin-bottom:30px;}', (0, _mixins.customDevice)(768, 1024), '{font-size:30px;line-height:normal;}');
	
	var HeadingDescription = /*#__PURE__*/exports.HeadingDescription = (0, _reactEmotion2.default)(_Din.Typo24PumpkinOrangeDDI, {
	  target: 'e1vectcb4'
	})('letter-spacing:0.5px;padding-bottom:10px;text-shadow:0 4px 8px ', _Colors2.default.black10, ';', _mixins.mobile, '{font-size:20px;}');
	
	var ButtonDescription = /*#__PURE__*/exports.ButtonDescription = (0, _reactEmotion2.default)(_Din.Typo16WhiteDR, {
	  target: 'e1vectcb5'
	})('letter-spacing:1px;pointer-events:none;', _mixins.mobile, '{font-size:12px;letter-spacing:0.5px;}');

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1036);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TestimonialDescriptionImageItem = function (_Component) {
	  _inherits(TestimonialDescriptionImageItem, _Component);
	
	  function TestimonialDescriptionImageItem() {
	    _classCallCheck(this, TestimonialDescriptionImageItem);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TestimonialDescriptionImageItem.prototype.render = function render() {
	    var _props = this.props,
	        testimonialDescription = _props.testimonialDescription,
	        testimonialName = _props.testimonialName,
	        style = _props.style,
	        className = _props.className,
	        id = _props.id,
	        country = _props.country;
	
	    return _react2.default.createElement(
	      _styledComponents.TestimonialDescriptionImageItemContainer,
	      {
	        className: className,
	        id: id,
	        style: style
	      },
	      _react2.default.createElement(
	        _styledComponents.TestimonialContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.TestimonialDescriptionContainer,
	          null,
	          _react2.default.createElement(_styledComponents.TestimonialDescription, {
	            dangerouslySetInnerHTML: {
	              __html: testimonialDescription
	            }
	          }),
	          _react2.default.createElement(
	            _styledComponents.TestimonialName,
	            null,
	            testimonialName
	          ),
	          _react2.default.createElement(
	            _styledComponents.CountryName,
	            null,
	            country
	          )
	        )
	      )
	    );
	  };
	
	  return TestimonialDescriptionImageItem;
	}(_react.Component);
	
	exports.default = TestimonialDescriptionImageItem;
	module.exports = exports['default'];

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TestimonialContainer = exports.CountryName = exports.TestimonialName = exports.TestimonialDescription = exports.TestimonialDescriptionContainer = exports.TestimonialDescriptionImageItemContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestimonialDescriptionImageItemContainer = /*#__PURE__*/exports.TestimonialDescriptionImageItemContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1av39au0'
	})('margin-right:24px !important;:nth-last-child(1){margin-right:0;', (0, _mixins.customDevice)(320, 601), '{margin-right:unset !important;}}', (0, _mixins.customDevice)(320, 601), '{margin-left:unset !important;margin-right:unset !important;}', (0, _mixins.minDeviceWidth)(768), '{width:18% !important;}');
	var TestimonialDescriptionContainer = /*#__PURE__*/exports.TestimonialDescriptionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1av39au1'
	})('display:flex;flex-direction:column;', _mixins.mobile, '{padding-top:20px;}');
	var TestimonialDescription = /*#__PURE__*/exports.TestimonialDescription = (0, _reactEmotion2.default)(_Din.Typo16PinkishGreyDI, {
	  target: 'e1av39au2'
	})('line-height:1.5;padding-bottom:10px;margin-left:10px;margin-right:10px;', _mixins.mobile, '{font-size:14px;padding-bottom:0px;line-height:1.57;margin-left:20px;margin-right:20px;}');
	var TestimonialName = /*#__PURE__*/exports.TestimonialName = (0, _reactEmotion2.default)(_Din.Typo18WhiteFourDefaultDDI, {
	  target: 'e1av39au3'
	})('line-height:normal;text-align:right;margin-right:5px;', _mixins.mobile, '{font-size:15px;margin-right:20px;}');
	
	var CountryName = /*#__PURE__*/exports.CountryName = (0, _reactEmotion2.default)(_Din.Typo14PinkishGreyDDI, {
	  target: 'e1av39au4'
	})('text-align:right;line-height:normal;letter-spacing:normal;margin-right:5px;', _mixins.mobile, '{margin-right:20px;}');
	
	var TestimonialContainer = /*#__PURE__*/exports.TestimonialContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1av39au5'
	})('display:flex;padding-top:30px;', (0, _mixins.customDevice)(320, 601), '{flex-direction:column;align-items:center;padding-top:20px;}');

/***/ }),

/***/ 2252:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(102);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _IcLeftArrow = __webpack_require__(131);
	
	var _IcLeftArrow2 = _interopRequireDefault(_IcLeftArrow);
	
	var _SectionHeading = __webpack_require__(675);
	
	var _SectionHeading2 = _interopRequireDefault(_SectionHeading);
	
	var _IcRightArrow = __webpack_require__(132);
	
	var _IcRightArrow2 = _interopRequireDefault(_IcRightArrow);
	
	var _responsiveUtils = __webpack_require__(27);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _TestimonialDescriptionImageItem = __webpack_require__(1035);
	
	var _TestimonialDescriptionImageItem2 = _interopRequireDefault(_TestimonialDescriptionImageItem);
	
	__webpack_require__(2252);
	
	var _styledComponents = __webpack_require__(1038);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarsAboutIbCricket = function (_Component) {
	  _inherits(StarsAboutIbCricket, _Component);
	
	  function StarsAboutIbCricket(props) {
	    _classCallCheck(this, StarsAboutIbCricket);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.next = function () {
	      _this.slider.slickNext();
	    };
	
	    _this.previous = function () {
	      _this.slider.slickPrev();
	    };
	
	    _this.dragging = function (e) {
	      e.preventDefault();
	    };
	
	    _this.testimonialStopSliding = function (index) {
	      _this.setState({
	        testimonialIndex: index
	      });
	    };
	
	    _this.renderTestimonials = function (testimonialsData) {
	      return testimonialsData.map(function (testimonial) {
	        return _react2.default.createElement(_TestimonialDescriptionImageItem2.default, {
	          key: testimonial.testimonialId,
	          id: testimonial.testimonialId,
	          country: testimonial.country,
	          testimonialDescription: testimonial.description,
	          testimonialName: testimonial.name,
	          imageUrl: testimonial.imageUrl
	        });
	      });
	    };
	
	    _this.state = {
	      testimonialIndex: 0,
	      testimonialMaxIndexLimit: 1
	    };
	    return _this;
	  }
	
	  StarsAboutIbCricket.prototype.componentDidMount = function componentDidMount() {
	    var testimonialsList = this.props.testimonials.testimonialsList;
	
	    if ((0, _responsiveUtils.customMaxWidth)(1101)) {
	      // TODO: At this break point 1100, In the slick we need to change the number of cards to be displayed for proper alignment.
	      // eslint-disable-next-line
	      this.setState({
	        testimonialMaxIndexLimit: testimonialsList.length - 1
	      });
	    } else {
	      // eslint-disable-next-line
	      this.setState({
	        testimonialMaxIndexLimit: testimonialsList.length - 2
	      });
	    }
	  };
	
	  StarsAboutIbCricket.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        testimonialIndex = _state.testimonialIndex,
	        testimonialMaxIndexLimit = _state.testimonialMaxIndexLimit;
	    var _props$testimonials = this.props.testimonials,
	        testimonialsHeading = _props$testimonials.testimonialsHeading,
	        testimonialsList = _props$testimonials.testimonialsList;
	
	
	    var testimonialsSlickSettings = {
	      dots: false,
	      infinite: true,
	      autoplay: true,
	      speed: 500,
	      autoplaySpeed: 10000,
	      slidesToShow: 2,
	      slidesToScroll: 1,
	      afterChange: this.testimonialStopSliding,
	      arrows: false,
	      draggable: true,
	      responsive: [{
	        breakpoint: 602,
	        settings: {
	          dots: false,
	          infinite: true,
	          autoplay: true,
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          arrows: false,
	          draggable: true
	        }
	      }, {
	        breakpoint: 1101,
	        settings: {
	          infinite: true,
	          autoplay: true,
	          slidesToShow: 2,
	          slidesToScroll: 1,
	          arrows: false,
	          draggable: true
	        }
	      }]
	    };
	    return _react2.default.createElement(
	      _styledComponents.StarsAboutIbCricketSection,
	      null,
	      _react2.default.createElement(
	        _styledComponents.StarsAboutIbCricketContainer,
	        null,
	        _react2.default.createElement(_SectionHeading2.default, {
	          sectionHeadingText: testimonialsHeading,
	          color: _Colors2.default.pumpkinOrange
	        }),
	        _react2.default.createElement(
	          _styledComponents.SliderContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.PrevArrowSection,
	            {
	              id: 'events-testimonials-prev-arrow',
	              onClick: this.previous
	            },
	            _react2.default.createElement(
	              _styledComponents.TestimonialsSvgContainer,
	              { disableArrow: testimonialIndex === 0 },
	              _react2.default.createElement(_IcLeftArrow2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactSlick2.default,
	            _extends({
	              ref: function ref(c) {
	                _this2.slider = c;
	              },
	              className: 'ExperimentalTestimonialsSlickSection'
	            }, testimonialsSlickSettings),
	            this.renderTestimonials(testimonialsList)
	          ),
	          _react2.default.createElement(
	            _styledComponents.NextArrowSection,
	            {
	              onClick: testimonialIndex >= testimonialMaxIndexLimit ? null : this.next,
	              id: 'events-testimonials-next-arrow'
	            },
	            _react2.default.createElement(
	              _styledComponents.TestimonialsSvgContainer,
	              {
	                disableArrow: testimonialIndex >= testimonialMaxIndexLimit
	              },
	              _react2.default.createElement(_IcRightArrow2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return StarsAboutIbCricket;
	}(_react.Component);
	
	StarsAboutIbCricket.defaultProps = {
	  title: 'Testimonials'
	};
	exports.default = StarsAboutIbCricket;
	module.exports = exports['default'];

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrowSection = exports.TestimonialsSvgContainer = exports.SliderContainer = exports.PrevArrowSection = exports.StarsAboutIbCricketContainer = exports.ResponsiveContainer = exports.StarsAboutIbCricketSection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StarsAboutIbCricketSection = /*#__PURE__*/exports.StarsAboutIbCricketSection = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n0'
	})('background-color:', _Colors2.default.darkTwoDefault, ';padding-top:60px;padding-bottom:60px;', _mixins.mobile, '{padding-top:40px;padding-bottom:40px;}');
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n1'
	})('width:1124px;margin:auto;display:flex;flex-direction:column;', _mixins.mobile, '{width:88.8%;margin:auto;}', _mixins.tablet, '{width:90%;margin:auto;}', (0, _mixins.customDevice)(1024, 1140), '{width:90%;margin:auto;}');
	
	var StarsAboutIbCricketContainer = /*#__PURE__*/exports.StarsAboutIbCricketContainer = (0, _reactEmotion2.default)(ResponsiveContainer, {
	  target: 'e12rkm7n2'
	})((0, _mixins.customDevice)(1140, 1250), '{width:90%;margin:auto;}');
	
	var PrevArrowSection = /*#__PURE__*/exports.PrevArrowSection = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n3'
	})('position:absolute;left:-4%;top:34%;z-index:10;cursor:pointer;', (0, _mixins.customDevice)(320, 602), '{left:-3%;top:30%;}', (0, _mixins.customDevice)(602, 768), '{left:-4%;}');
	var SliderContainer = /*#__PURE__*/exports.SliderContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n4'
	})('position:relative;');
	
	var TestimonialsSvgContainer = /*#__PURE__*/exports.TestimonialsSvgContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n5'
	})('pointer-events:none;user-select:none;display:flex;opacity:', function (props) {
	  return props.disableArrow ? '0.4' : null;
	}, ';');
	var NextArrowSection = /*#__PURE__*/exports.NextArrowSection = (0, _reactEmotion2.default)('div', {
	  target: 'e12rkm7n6'
	})('cursor:pointer;position:absolute;right:-4%;top:34%;z-index:10;', (0, _mixins.customDevice)(320, 602), '{right:-3%;top:30%;}', (0, _mixins.customDevice)(602, 768), '{right:-4%;}');

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1046);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionHeading = function (_Component) {
	  _inherits(SectionHeading, _Component);
	
	  function SectionHeading() {
	    _classCallCheck(this, SectionHeading);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SectionHeading.prototype.render = function render() {
	    var _props = this.props,
	        sectionHeadingText = _props.sectionHeadingText,
	        color = _props.color;
	
	    return _react2.default.createElement(
	      _styledComponents.SectionHeadingContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.SectionHeadingText,
	        { as: 'h2' },
	        sectionHeadingText
	      ),
	      _react2.default.createElement(_styledComponents.SectionHeadingLine, { color: color })
	    );
	  };
	
	  return SectionHeading;
	}(_react.Component);
	
	exports.default = SectionHeading;
	module.exports = exports['default'];

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SectionHeadingLine = exports.SectionHeadingText = exports.SectionHeadingContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Nort = __webpack_require__(11);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeadingContainer = /*#__PURE__*/exports.SectionHeadingContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1d5k52g0'
	})();
	
	var SectionHeadingText = /*#__PURE__*/exports.SectionHeadingText = (0, _reactEmotion2.default)(_Nort.Typo30WhiteTwoBNBI, {
	  target: 'e1d5k52g1'
	})('letter-spacing:0.5px;line-height:normal;margin-top:0px;margin-bottom:0px;', _mixins.mobile, '{font-size:22px;letter-spacing:0.5px;}');
	var SectionHeadingLine = /*#__PURE__*/exports.SectionHeadingLine = (0, _reactEmotion2.default)('div', {
	  target: 'e1d5k52g2'
	})('width:100px;border:1px solid ', function (props) {
	  return props.color;
	}, ';margin-top:10px;', _mixins.mobile, '{margin-top:8px;}');

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ResponsiveContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1b870v10'
	})('width:1124px;margin:auto;display:flex;flex-direction:column;', _mixins.mobile, '{width:88.8%;margin:auto;}', _mixins.tablet, '{width:90%;margin:auto;}', (0, _mixins.customDevice)(1024, 1140), '{width:90%;margin:auto;}');

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcLeftArrow = function (_Component) {
	  _inherits(IcLeftArrow, _Component);
	
	  function IcLeftArrow() {
	    _classCallCheck(this, IcLeftArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IcLeftArrow.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "13",
	        height: "24",
	        viewBox: "0 0 13 24"
	      },
	      _react2.default.createElement("path", {
	        fill: "#DADADA",
	        fillRule: "nonzero",
	        d: "M11.452 23.651L.33 12.595a.838.838 0 0 1 0-1.19L11.452.35a.85.85 0 0 1 1.197 0c.33.328.33.861 0 1.19L2.125 12 12.65 22.462c.33.328.33.861 0 1.19a.829.829 0 0 1-.598.245.829.829 0 0 1-.599-.246z"
	      })
	    );
	  };
	
	  return IcLeftArrow;
	}(_react.Component);
	
	exports.default = IcLeftArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(217);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcLeftArrow = function (_Component) {
	  _inherits(IcLeftArrow, _Component);
	
	  function IcLeftArrow() {
	    _classCallCheck(this, IcLeftArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IcLeftArrow.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return IcLeftArrow;
	}(_react.Component);
	
	exports.default = IcLeftArrow;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcRightArrow = function (_Component) {
	  _inherits(IcRightArrow, _Component);
	
	  function IcRightArrow() {
	    _classCallCheck(this, IcRightArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IcRightArrow.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "13",
	        height: "24",
	        viewBox: "0 0 13 24"
	      },
	      _react2.default.createElement("path", {
	        fill: "#DADADA",
	        fillRule: "nonzero",
	        d: "M1.527 23.651a.829.829 0 0 1-.598.246.829.829 0 0 1-.599-.246.838.838 0 0 1 0-1.19L10.854 12 .33 1.538a.838.838 0 0 1 0-1.19.85.85 0 0 1 1.197 0l11.122 11.057c.33.328.33.862 0 1.19L1.527 23.65z"
	      })
	    );
	  };
	
	  return IcRightArrow;
	}(_react.Component);
	
	exports.default = IcRightArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(218);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcRightArrow = function (_Component) {
	  _inherits(IcRightArrow, _Component);
	
	  function IcRightArrow() {
	    _classCallCheck(this, IcRightArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IcRightArrow.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return IcRightArrow;
	}(_react.Component);
	
	exports.default = IcRightArrow;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_React$Component) {
	  _inherits(SEO, _React$Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var SEOData = this.props.SEOData;
	    var title = SEOData.title,
	        description = SEOData.description,
	        ogTitle = SEOData.ogTitle,
	        ogUrl = SEOData.ogUrl,
	        ogImage = SEOData.ogImage,
	        ogDescription = SEOData.ogDescription,
	        ogSiteName = SEOData.ogSiteName,
	        ogType = SEOData.ogType,
	        twitterTitle = SEOData.twitterTitle,
	        twitterUrl = SEOData.twitterUrl,
	        twitterDescription = SEOData.twitterDescription,
	        twitterImage = SEOData.twitterImage,
	        twitterSite = SEOData.twitterSite,
	        schemaData = SEOData.schemaData,
	        canonicalUrl = SEOData.canonicalUrl,
	        isRobotsTextEnabled = SEOData.isRobotsTextEnabled;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      schemaData && _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        '' + schemaData
	      ),
	      title && _react2.default.createElement(
	        'title',
	        null,
	        title
	      ),
	      description && _react2.default.createElement('meta', { name: 'description', content: description }),
	      ogTitle && _react2.default.createElement('meta', { property: 'og:title', content: ogTitle }),
	      ogUrl && _react2.default.createElement('meta', { property: 'og:url', content: ogUrl }),
	      ogImage && _react2.default.createElement('meta', { property: 'og:image', content: ogImage }),
	      ogDescription && _react2.default.createElement('meta', { property: 'og:description', content: ogDescription }),
	      ogType && _react2.default.createElement('meta', { property: 'og:type', content: ogType }),
	      ogSiteName && _react2.default.createElement('meta', { property: 'og:site_name', content: ogSiteName }),
	      twitterTitle && _react2.default.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	      twitterUrl && _react2.default.createElement('meta', { name: 'twitter:url', content: twitterUrl }),
	      twitterSite && _react2.default.createElement('meta', { name: 'twitter:site', content: twitterSite }),
	      twitterDescription && _react2.default.createElement('meta', { property: 'twitter:description', content: twitterDescription }),
	      twitterImage && _react2.default.createElement('meta', { name: 'twitter:image', content: twitterImage }),
	      canonicalUrl && _react2.default.createElement('link', { rel: 'canonical', href: canonicalUrl }),
	      isRobotsTextEnabled && _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	    );
	  };
	
	  return SEO;
	}(_react2.default.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.graphqlQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(20);
	
	var _SEO = __webpack_require__(220);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _LandingPage = __webpack_require__(1033);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	var _EventsDescriptionSection = __webpack_require__(1029);
	
	var _EventsDescriptionSection2 = _interopRequireDefault(_EventsDescriptionSection);
	
	var _TestimonialSlick = __webpack_require__(1037);
	
	var _TestimonialSlick2 = _interopRequireDefault(_TestimonialSlick);
	
	var _IbCricketHostingSection = __webpack_require__(1031);
	
	var _IbCricketHostingSection2 = _interopRequireDefault(_IbCricketHostingSection);
	
	var _bookNowFormConstants = __webpack_require__(31);
	
	var _bookNowFormConstants2 = _interopRequireDefault(_bookNowFormConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Events = function (_Component) {
	  _inherits(Events, _Component);
	
	  function Events(props) {
	    _classCallCheck(this, Events);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.initMap = function () {
	      _this.setState({
	        glsLoaded: true
	      });
	    };
	
	    _this.state = {
	      glsLoaded: false
	    };
	    return _this;
	  }
	
	  Events.prototype.loadGooglePlacesScript = function loadGooglePlacesScript() {
	    try {
	      window.initMap = this.initMap;
	      var gmapScriptEl = document.createElement('script');
	      gmapScriptEl.src = _bookNowFormConstants2.default.GOOGLE_SCRIPT_URL;
	      document.querySelector('body').insertAdjacentElement('beforeend', gmapScriptEl);
	    } catch (error) {}
	  };
	
	  Events.prototype.componentDidMount = function componentDidMount() {
	    if (!window.google) {
	      this.loadGooglePlacesScript();
	    }
	    if (window.google) {
	      this.initMap();
	    }
	  };
	
	  Events.prototype.render = function render() {
	    var _props = this.props,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        data = _props.data,
	        isBookNowSlotOpened = _props.isBookNowSlotOpened,
	        bookNowModalData = _props.bookNowModalData;
	    var glsLoaded = this.state.glsLoaded;
	    var eventsHostedSectionData = data.eventsHostedSectionData.edges,
	        formData = data.applyForFranchiseData.edges;
	
	    var eventsHostedSectionDataProps = eventsHostedSectionData[0].node.frontmatter;
	    var eventsLandingSection = eventsHostedSectionDataProps.eventsLandingSection,
	        eventsHostedAtHeader = eventsHostedSectionDataProps.eventsHostedAtHeader,
	        eventsSection = eventsHostedSectionDataProps.eventsSection,
	        testimonials = eventsHostedSectionDataProps.testimonials,
	        seoData = eventsHostedSectionDataProps.seoData;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SEO2.default, { SEOData: seoData }),
	      _react2.default.createElement(_Header2.default, {
	        hideLogoByDefault: true,
	        formData: formData,
	        headerPropsData: headerPropsData,
	        isBookNowSlotOpened: isBookNowSlotOpened,
	        bookNowModalData: bookNowModalData
	      }),
	      _react2.default.createElement(_LandingPage2.default, { eventsLandingSection: eventsLandingSection }),
	      _react2.default.createElement(_IbCricketHostingSection2.default, { eventsHostedAtHeader: eventsHostedAtHeader }),
	      _react2.default.createElement(_EventsDescriptionSection2.default, {
	        eventsSection: eventsSection,
	        glsLoaded: glsLoaded
	      }),
	      _react2.default.createElement(_TestimonialSlick2.default, { testimonials: testimonials }),
	      _react2.default.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	    );
	  };
	
	  return Events;
	}(_react.Component);
	
	exports.default = Events;
	
	// eslint-disable-next-line
	
	var graphqlQuery = exports.graphqlQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-and-parties-index-js-75954e28aa1130161723.js